import React from 'react';
import { selectToasts } from '../redux/selectors';
import { connect } from 'react-redux';
import tclocal from '../ter/ter-consts-local-lib';

const ToastBig = (props) => {
  // TOASTS FOR BIG SCREENS
  let jsx = null;
  // console.log(props.toasts)
  jsx = props.toasts.map((toast) => {
    let cl_closing = '';
    if (toast.toastClosing === true) {
      cl_closing = " animate-close";
    }
    let cl_color = '';
    cl_color = ' blue'; // DEFAULT color
    switch (toast.color) {
      case tclocal.BLUE:
        cl_color = ' blue';
        break;
      case tclocal.GREEN:
        cl_color = ' green';
        break;
      case tclocal.RED:
        cl_color = ' red';
        break;
      case tclocal.ORANGE:
        cl_color = ' orange';
        break;
    }
    return (
      <div key={toast.id} className={"toast-item " + cl_closing}><span className={"toast " + cl_color}>{toast.title}</span></div>
    );
  });

  return (
    <>
      <div className="toast-big-container">
        {jsx}
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    toasts: selectToasts(state)
  };
}
export default connect(mapStateToProps)(ToastBig);